import { render } from "./PasswordVisibility.vue?vue&type=template&id=40d0c4ba"
import script from "./PasswordVisibility.vue?vue&type=script&lang=js"
export * from "./PasswordVisibility.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__